import styles from "./styles/subscription-price-block.module.scss";
import React from "react";
import { SubscriptionInfo } from "@/data/license.data";

interface SubscriptionPriceBlockProps {
  subscriptionInfo: SubscriptionInfo;
  formattedPrice: string | null;
}

const SubscriptionPriceBlock = ({
  subscriptionInfo,
  formattedPrice,
}: SubscriptionPriceBlockProps) => {
  return (
    <div className={styles.prices_info}>
      <div className={styles.prices_container}>
        <div className={styles.price_wrapper}>
          <div className={styles.price}>
            ${formattedPrice ? formattedPrice : subscriptionInfo.price}
          </div>
          <div className={styles.subtype}> /month</div>
        </div>

        {formattedPrice && (
          <div className={styles.old_price}>
            <div className={styles.monthly_price}>
              ${subscriptionInfo.price}
              <div className={styles.line} />
            </div>
            <div className={styles.subtype_yearly}> /month</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPriceBlock;
